<template>
  <div id="app">
    <router-view  />
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return{
     spinShow:false,
    }
  },
  mounted:function(){
    window.localStorage.setItem("scanCodeUrl", location.href);
  }
}
</script>
<style>
 @import 'styles/style.css';
@import './font/iconfont.css';
body{
  background: #F4F4F4;
}
.mint-swipe-indicator{
  background: #000;
  border: 1px solid black
}
.mint-swipe-indicator.is-active{
  background: #ddd;
}
</style>
